import { render } from "./tournament_header_section.vue?vue&type=template&id=b9308a0e"
import script from "./tournament_header_section.vue?vue&type=script&lang=js"
export * from "./tournament_header_section.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__